import script from "./LottScan.vue?vue&type=script&setup=true&lang=js"
export * from "./LottScan.vue?vue&type=script&setup=true&lang=js"

import "./LottScan.vue?vue&type=style&index=0&id=7e4dcac0&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4dcac0"]])

export default __exports__